import { getCookie } from '../../client/utils';
import { USER_ID_COOKIE_NAME } from '../constants';

export const getUserIdCookie = () => getCookie(USER_ID_COOKIE_NAME);
